export const ATTENDANCE_TAB = 'Attendance';
// Teacher-only: shown after the assessment tabs, so it isn't part of ASSESSMENT_TABS (which the student page also uses).
export const GRADES_SUMMARY_TAB = 'Grades Summary';

// A teacher's own subject page opened on its Attendance tab, showing the given section.
export const subjectAttendanceLink = (subjectId, section) => {
  const params = new URLSearchParams({ tab: ATTENDANCE_TAB });
  if (section) params.set('section', section);
  return `/dashboard/grades/${subjectId}?${params}`;
};

// Assessment components shown per subject, on both the student's and the teacher's subject page.
export const ASSESSMENT_TABS = [ATTENDANCE_TAB, 'Quizzes/Written Works', 'Performance Task', 'Examination'];

// The graded tabs, keyed by tab name. `component` is what assessments.component stores in the DB.
export const ASSESSMENT_COMPONENTS = {
  'Quizzes/Written Works': { component: 'written_work', addLabel: 'Add Quiz/WW', itemLabel: 'Quiz/WW' },
  'Performance Task': { component: 'performance_task', addLabel: 'Add Performance Task', itemLabel: 'Performance Task' },
  Examination: { component: 'examination', addLabel: 'Add Examination', itemLabel: 'Examination' },
};
